import { useSelector } from "react-redux";
import { Reservations } from "redux/reducers/reservationsSlice";
import { RootSliceType } from "redux/reducers/rootReducer";

export const useReservationsSelector = () => {
  const inividualReservations = useSelector<
    RootSliceType,
    Reservations["inividualReservations"]
  >((state) => state.reservations.inividualReservations);

  const groupReservations = useSelector<
    RootSliceType,
    Reservations["groupReservations"]
  >((state) => state.reservations.groupReservations);  

  const reservingLesson = useSelector<
    RootSliceType,
    Reservations["reservingLesson"]
  >((state) => state.reservations.reservingLesson);

  const scheduleCalanderOpen = useSelector<
    RootSliceType,
    Reservations["scheduleCalanderOpen"]
  >((state) => state.reservations.scheduleCalanderOpen);

  const selectedExpertSchedule = useSelector<
    RootSliceType,
    Reservations["selectedExpertSchedule"]
  >((state) => state.reservations.selectedExpertSchedule);

  const getSelectedReservationTimeslots = useSelector<
    RootSliceType,
    Reservations["selectedReservationTimeSlots"]
  >((state) => state.reservations.selectedReservationTimeSlots);

  const getFinalTimeslots = useSelector<
    RootSliceType,
    Reservations["finalTimeslots"]
  >((state) => state.reservations.finalTimeslots);

  const selectReservationMode = useSelector<
    RootSliceType,
    Reservations["reservationMode"]
  >((state) => state.reservations.reservationMode);

  const isLoading =  useSelector<
  RootSliceType,
  Reservations['loading']
>((state) => state.reservations.loading);

  return {
    inividualReservations,
    groupReservations,
    reservingLesson,
    scheduleCalanderOpen,
    selectedExpertSchedule,
    getSelectedReservationTimeslots,
    getFinalTimeslots,
    selectReservationMode,
    isLoading,
  };
};

export default useReservationsSelector;
